import React, { Component } from 'react';
import styles from './Application.css';
import { withStyles } from '@material-ui/core/styles';
import PrimaryAppBar from './AppBar/PrimaryAppBar';
import MainContainer from './MainContainer';
import Footer from './Footer';
import { BrowserRouter as Router, Route } from "react-router-dom";

class Application extends Component {

    render() {
        const { classes } = this.props;
        return (
            <Router>
                <Route
                    render={ ({location}) => (
                        <div className={classes.Application}>
                            <PrimaryAppBar />
                            <MainContainer location={location}/>
                            <Footer />
                        </div>
                    )}
                />
                                   
            </Router>
        );
    }
}

export default withStyles(styles, {withTheme: true})(Application);
